import lottie from 'lottie-web';
import Logger from './logger';

class MixtapeLoadAnim extends HTMLElement {
  #NAME ='MixtapeLoadAnim';
  #animation;

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    this.#animation = lottie.loadAnimation({
      container: this,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/wp-content/themes/wonderpress/static/dist/js/loadingV4.json'
    });
  }

  disconnectedCallback() {
    Logger.info(`${this.#NAME} > disconnectedCallback`);
    this.#animation.destroy();
    this.#animation = null;
  }
}

customElements.define('mixtape-load-anim', MixtapeLoadAnim);